function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useCallback, useContext } from 'react';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import { activeAccountGroupSelector, activeAccountSubGroupSelector } from '@signal/core/auth/selectors';
import { activeAccountNameSelector, cookActiveAccountForSelectors } from '@signal/core/auth';
import { useContextsInReduxForm } from '@signal/core/contextFetch/hooks';
import { cookRecentlyViewedAccountsForSelectors, hasRecentlyViewedAccountsSelector } from '@signal/core/local/selectors';
import { initialsSelector, accountsLoadingSelector, cookUserAccountsForSelectors, cookUserDetailsForSelectors } from '@signal/core/user/selectors';
import { ActiveAccountContext, UserAccountsContext, UserDetailsContext } from '@signal/core/user/Context';
import createPersistedState from '@signal/core-hooks/usePersistedState';
import renderIf from '@signal/utils/renderIf';
import { AccountMenu, Popover, Trigger, Divider, ButtonWrapper, ButtonTitle, Avatar, LogoutButtonWrapper, LogoutButton, FontSlider, IconWrapper } from './styles';
import DealerGroup from '../DealerGroup';
import FontSizeIcon from '../Icons/FontSize';
import PopoverContext, { usePopover } from '../Popover/Context';
import PopoverContent from '../PopoverContent';
import RecentAccountsList from '../RecentAccountsList';
import Skeleton from './Skeleton';
import UserDetailsBadge from '../UserDetailsBadge';
var anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right'
};
var transformOrigin = {
  vertical: 'top',
  horizontal: 'right'
};
var useGlobalFontSize = createPersistedState('globalFontSize');

function ValueLabelComponent(props) {
  var children = props.children,
      open = props.open,
      value = props.value;
  return /*#__PURE__*/React.createElement(Tooltip, {
    open: open,
    enterTouchDelay: 0,
    placement: "top",
    title: "".concat(value, "%")
  }, children);
}

function Content(_ref) {
  var onAccountChange = _ref.onAccountChange,
      onLogout = _ref.onLogout,
      selectorState = _ref.selectorState,
      showFontSlider = _ref.showFontSlider,
      UserMenuNavLinks = _ref.UserMenuNavLinks; // const darkMode = useDarkMode()

  var hasRecentAccounts = hasRecentlyViewedAccountsSelector(selectorState);
  var activeAccountGroup = activeAccountGroupSelector(selectorState);
  var activeAccountSubGroup = activeAccountSubGroupSelector(selectorState);

  var _usePopover = usePopover(),
      handleClose = _usePopover.handleClose;

  var _useGlobalFontSize = useGlobalFontSize(100),
      _useGlobalFontSize2 = _slicedToArray(_useGlobalFontSize, 2),
      globalFontSize = _useGlobalFontSize2[0],
      setGlobalFontSize = _useGlobalFontSize2[1];

  var onChange = useCallback(function (evt, fontSize) {
    return setGlobalFontSize(fontSize);
  }, [setGlobalFontSize]);
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(AccountMenu, null, /*#__PURE__*/React.createElement(UserDetailsBadge, null), renderIf(activeAccountGroup || activeAccountSubGroup, function () {
    return /*#__PURE__*/React.createElement(DealerGroup, {
      onAccountChange: onAccountChange
    });
  }), renderIf(hasRecentAccounts, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(RecentAccountsList, {
      onAccountChange: onAccountChange
    }));
  }), renderIf(UserMenuNavLinks, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(UserMenuNavLinks, null));
  })), /*#__PURE__*/React.createElement(LogoutButtonWrapper, null, renderIf(showFontSlider, function () {
    return /*#__PURE__*/React.createElement(FontSlider, null, /*#__PURE__*/React.createElement(Slider, {
      ValueLabelComponent: ValueLabelComponent,
      "aria-label": "custom thumb label",
      defaultValue: globalFontSize,
      onChangeCommitted: onChange,
      min: 90,
      max: 120,
      step: 10,
      track: false
    }), /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(FontSizeIcon, {
      size: 8
    }), /*#__PURE__*/React.createElement(FontSizeIcon, {
      size: 10
    }), /*#__PURE__*/React.createElement(FontSizeIcon, {
      size: 12
    }), /*#__PURE__*/React.createElement(FontSizeIcon, {
      size: 14
    })));
  }), /*#__PURE__*/React.createElement(LogoutButton, {
    onClick: onLogout
  }, "Sign Out")));
}

var REDUX_COOKERS = [{
  context: ActiveAccountContext,
  cookers: [cookActiveAccountForSelectors, cookRecentlyViewedAccountsForSelectors]
}, {
  context: UserAccountsContext,
  cookers: [cookUserAccountsForSelectors]
}, {
  context: UserDetailsContext,
  cookers: [cookUserDetailsForSelectors]
}];

function MainNavUserMenu(_ref2) {
  var onAccountChange = _ref2.onAccountChange,
      rest = _objectWithoutProperties(_ref2, ["onAccountChange"]);

  var _useContext = useContext(ActiveAccountContext),
      changeActiveAccount = _useContext.changeActiveAccount;

  var selectorState = useContextsInReduxForm(REDUX_COOKERS);
  var initials = initialsSelector(selectorState);
  var title = activeAccountNameSelector(selectorState);
  var loading = accountsLoadingSelector(selectorState);
  var handleAccountChange = useCallback(function (account) {
    return function () {
      changeActiveAccount(account);
      onAccountChange(account);
    };
  }, [onAccountChange, changeActiveAccount]);
  return /*#__PURE__*/React.createElement(Popover, null, /*#__PURE__*/React.createElement(Trigger, null, /*#__PURE__*/React.createElement(PopoverContext.Consumer, null, function (_ref3) {
    var open = _ref3.open;
    return renderIf(loading && !open, function () {
      return /*#__PURE__*/React.createElement(Skeleton, null);
    }, function () {
      return /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(ButtonTitle, null, title), /*#__PURE__*/React.createElement(Avatar, null, initials));
    });
  })), /*#__PURE__*/React.createElement(PopoverContent, {
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    elevation: 2
  }, /*#__PURE__*/React.createElement(Content, Object.assign({}, rest, {
    onAccountChange: handleAccountChange,
    selectorState: selectorState
  }))));
}

export default MainNavUserMenu;